module.exports = __webpack_public_path__ + "img/2.63846b9e.png";